module.exports = __webpack_public_path__ + "static/media/chat16.63e54d7c.svg";